import ActSwitchDialog from './ActSwitch.vue'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(ActSwitchDialog)

    //2.用new 的方式用组件构造器创建出来组件对象
    const actSwitchDialog = new Construct({ store, router })

    //3.将组件对象手动挂载到某一个元素上
    actSwitchDialog.$mount(document.createElement('div'))

    //4.actSwitchDialog.$el对应的就是div
    document.body.appendChild(actSwitchDialog.$el)

    //5.在原型中加入actSwitchDialog
    Vue.prototype.$ActSwitchDialog = actSwitchDialog
}

export default obj
